// Platformbeheerder (PLATFORM_ADMIN_EMAILS), handgeschreven zoals family.ts en gelijk aan de API
// (apps/api/src/routes/v1/app/platform.ts, schema in @amumin/domain platform/werklijst.ts). Alleen
// de ouderapp van de beheerder gebruikt dit; de kiosk nooit. openapi.contract.test.ts bewaakt dat
// elke aanroep bestaat.
export function createPlatformClient({ request }) {
    const id = (v) => encodeURIComponent(v);
    return {
        /** 200 voor de beheerder; 404 voor ieder ander; 503 als het bestand ontbreekt of niet klopt. */
        werklijst: () => request('GET', '/v1/app/platform/werklijst'),
        /** Adviesstuk bij een punt (alleen .md onder docs/); 404 voor ieder ander en bij onbekend. */
        werklijstDoc: (path) => {
            // Het pad als query (de contracttest leest het pad tot aan de query).
            const search = `?path=${encodeURIComponent(path)}`;
            return request('GET', '/v1/app/platform/werklijst/doc' + search);
        },
        /** AMUMIN Beheer: voor ieder ander dan de beheerder 404 (net als de werklijst). */
        beheer: {
            status: () => request('GET', '/v1/app/platform/beheer/status'),
            /** Herbevestigen met een code per e-mail; daarna app.auth.challengeVerify. */
            reauthCode: () => request('POST', '/v1/app/platform/beheer/reauth/code', {}),
            households: () => request('GET', '/v1/app/platform/beheer/households'),
            /** POST: een e-mailadres gaat nooit in de URL. */
            search: (q) => request('POST', '/v1/app/platform/beheer/households/search', { q }),
            household: (householdId) => request('GET', `/v1/app/platform/beheer/households/${id(householdId)}`),
            create: (input) => request('POST', '/v1/app/platform/beheer/households', input),
            resendInvitation: (householdId) => request('POST', `/v1/app/platform/beheer/households/${id(householdId)}/invitation`, {}),
            pause: (householdId, paused, reason) => request('POST', `/v1/app/platform/beheer/households/${id(householdId)}/pause`, reason ? { paused, reason } : { paused }),
            scheduleDeletion: (householdId, reason) => request('POST', `/v1/app/platform/beheer/households/${id(householdId)}/deletion`, reason ? { reason } : {}),
            cancelDeletion: (householdId) => request('DELETE', `/v1/app/platform/beheer/households/${id(householdId)}/deletion`),
            support: (householdId) => request('GET', `/v1/app/platform/beheer/households/${id(householdId)}/support`),
            lookupAccount: (email) => request('POST', '/v1/app/platform/beheer/accounts/lookup', { email }),
            accountAction: (email, action) => request('POST', '/v1/app/platform/beheer/accounts/action', { email, action }),
            audit: () => request('GET', '/v1/app/platform/beheer/audit'),
        },
        /** Meekijken door AMUMIN (instellingen van het gezin; ouders lezen, de eigenaar beslist). */
        supportAccess: {
            get: () => request('GET', '/v1/app/support-access'),
            grant: (hours) => request('POST', '/v1/app/support-access', { hours }),
            revoke: () => request('DELETE', '/v1/app/support-access'),
        },
        /** Uitnodiging van een eigenaar (landingspagina /uitnodiging#token=…). */
        ownerInvite: {
            preview: (token) => request('POST', '/v1/app/invitations/owner/preview', { token }),
            acceptNew: (input) => request('POST', '/v1/app/invitations/owner/accept-new', input),
            accept: (token) => request('POST', '/v1/app/invitations/owner/accept', { token }),
        },
    };
}
//# sourceMappingURL=platform.js.map